import TitleH1 from "../Titles/title-h1";
import SearchInput from "./SearchInput";
import {useEffect, useState} from "react";
import api from "../../services/api";

const AdminUsers = () => {
    const [users, setUsers] = useState([]);
    const [roles, setRoles] = useState([]);
    console.log(roles);

    useEffect(() => {
        api.get('/handleUsers')
            .then((response) => {
                setUsers(response.data.users);
                setRoles(response.data.roles)
            })
            .catch((error) => {
                console.error('Failed to fetch users', error);
            })
    }, []);

    const handleSearch = () => {
            //@todo, develop a search method
    }


    return (
        <>
            <TitleH1>Users Management</TitleH1>
            <SearchInput handleSearch={handleSearch}/>

            <h2 className="text-2xl font-bold mb-6 text-gray-800">List of Users</h2>
            <table className="min-w-full border border-gray-300 divide-y divide-gray-200">
                <thead className="bg-gray-100">
                <tr>
                    <th className="px-4 py-2 text-left text-sm font-medium text-gray-600">Username</th>
                    <th className="px-4 py-2 text-left text-sm font-medium text-gray-600">Email</th>
                    <th className="px-4 py-2 text-left text-sm font-medium text-gray-600">Role</th>
                    <th className="px-4 py-2 text-left text-sm font-medium text-gray-600">Enabled</th>
                </tr>
                </thead>
                <tbody className="divide-y divide-gray-200">
                {users.map((user) => (
                    <tr key={user.id} className="hover:bg-gray-50">
                        <td className="px-4 py-2 text-sm text-gray-700">{user.name}</td>
                        <td className="px-4 py-2 text-sm text-gray-700">{user.email}</td>
                        <td className="px-4 py-2 text-sm text-gray-700">
                            {roles.find((role) => role.id === user.role_id)?.name || 'Unknown'}
                        </td>
                        <td className="px-4 py-2 text-sm text-gray-700">Enabled</td>
                    </tr>
                ))}
                </tbody>
            </table>

        </>
    )
}

export default AdminUsers;